import { createSlice } from '@reduxjs/toolkit';

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const initialState = {
  user: localStorage.getItem("user") && isJson(localStorage.getItem("user")) ? JSON.parse(localStorage.getItem("user")) : null,
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
};

const translationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData(state, action) {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.user = action.payload;
      state.isLogin = true;
    },
    setLogout(state, action) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      state.user = null;
      state.isLogin = false;
      state.token = "";
    },
    setToken: (state, { payload }) => {
      if(payload){
        localStorage.setItem('token', payload);
      }else{
        localStorage.removeItem('token');
      }
      state.token = payload;
    },
  },
});

export const { setUserData, setToken, setLogout } = translationSlice.actions;
const userReducer = translationSlice.reducer;

export default userReducer;
